/* The Lab EQ: make the product-page trust cards clickable */
(function () {
  var MAP = [
    [/tested/i, '/pages/terms-conditions'],
    [/warranty/i, '/pages/terms-conditions'],
    [/shipping/i, '/pages/shipping-return-policy']
  ];

  function linkCards() {
    var cards = document.querySelectorAll("[id*='product-information'] .layout-panel-flex--row > .group-block");
    cards.forEach(function (card) {
      if (!card.querySelector('.icon-block')) return;
      if (card.querySelector('a.labeq-trust-link')) return;
      var text = (card.textContent || '').trim();
      var match = MAP.find(function (pair) { return pair[0].test(text); });
      if (!match) return;
      var a = document.createElement('a');
      a.href = match[1];
      a.className = 'labeq-trust-link';
      while (card.firstChild) a.appendChild(card.firstChild);
      card.appendChild(a);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', linkCards);
  } else {
    linkCards();
  }
  document.addEventListener('shopify:section:load', linkCards);
})();
